export const getDefaultConfigs = (id) => ({
  "coins-winners-ticker": {
    display: {
      username: true,
      gameName: true,
      firstName: false,
      city: false,
      country: false,
    },
    categories: {
      ufGlobalLeaders: true,
      ufSoldCards: false,
      ufVersusWin: true,
      miniGames: true,
      megaSpin: true,
    },
    minAmount: 2000,
    quantityLimit: "50",
  },
  "ultimate-fan": {
    selectedTenantIds: [],
  },
  "prize-draw-active": {
    show: "2",
  },
  "prize-draw-winner": {
    show: "4",
  },
  "promo-carousel": {
    order: "sequential",
    autoRotate: false,
    lapseTime: "5",
    slides: [
      {
        id,
        title: "",
        linkType: "externalUrl",
        externalUrl: null,
        appPage: null,
        miniGames: null,
        slideOrderId: 1,
        imageUrl: "",
      },
    ],
  },
  "mini-game-section-box": {
    title: "",
    rankFilter: null,
    tagFilter: null,
    show: "10",
    allGames: false,
  },
  "mini-game-section-feature": {
    title: "",
    gameFilter: null,
    show: "10",
    allGames: false,
  },
  "mini-game-section-vert": {
    title: "",
    tagFilter: null,
    show: "10",
    allGames: false,
  },
  "mini-game-section-big": {
    title: "",
    tagFilter: null,
    show: "10",
    allGames: false,
  },
  "mini-game-section-full": {
    title: "",
    tagFilter: null,
    show: "10",
    allGames: false,
  },
  "hall-of-fame": {
    top: "10",
    today: true,
    week: true,
    month: true,
  },
  "advert-box": {
    linkType: "externalUrl",
    externalUrl: null,
    appPage: null,
    imageUrl: "",
  },
  "advert-half-box": {
    linkType: "externalUrl",
    externalUrl: null,
    appPage: null,
    imageUrl: "",
  },
  "advert-banner": {
    linkType: "externalUrl",
    externalUrl: null,
    appPage: null,
    imageUrl: "",
  },
});
